var _path, _path2;
var _excluded = ["title", "titleId", "desc", "descId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgPressDownload = function SvgPressDownload(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    desc = _ref.desc,
    descId = _ref.descId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    fill: "none",
    viewBox: "0 0 25 25",
    role: "img",
    "aria-labelledby": titleId,
    "aria-describedby": descId
  }, props), desc ? /*#__PURE__*/React.createElement("desc", {
    id: descId
  }, desc) : null, title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#E73C58",
    d: "M23.611 16.667a1.39 1.39 0 0 0-1.389 1.388v3.334a.835.835 0 0 1-.833.833H3.611a.835.835 0 0 1-.833-.833v-3.334a1.389 1.389 0 1 0-2.778 0v3.334a3.616 3.616 0 0 0 3.611 3.61h17.778A3.616 3.616 0 0 0 25 21.39v-3.334a1.39 1.39 0 0 0-1.389-1.389"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#E73C58",
    d: "M12.5 0a1.39 1.39 0 0 0-1.389 1.389v12.59l-4.388-3.657a1.39 1.39 0 0 0-1.956.178 1.39 1.39 0 0 0 .178 1.955l6.666 5.556q.105.075.223.129.075.05.158.091c.324.136.689.136 1.013 0a1.4 1.4 0 0 0 .155-.09q.117-.055.222-.129l6.667-5.555A1.39 1.39 0 0 0 19.167 10c-.325 0-.64.114-.89.322L13.89 13.98V1.389A1.39 1.39 0 0 0 12.5 0"
  })));
};
export default SvgPressDownload;